module.exports = __webpack_public_path__ + "img/usgs.0cda0d48.jpeg";